import { environment } from "@env/environment";
import { BaseModel } from "./base.model";

export class Image extends BaseModel {
    id!: string;
    url!: string;
    baseUrl!: string;

    getUrl(spec: string = '') {

        if (this.id) {
            let url = `${environment.apiBaseUrl}/${environment.instanceUuid}/images/${this.id}`;
            return spec ? `${url}?spec=${spec}` : url;
        }

        if (this.baseUrl) {
            return this.baseUrl;
        }

        return '/assets/img/icons/gallery.svg';
    }
}